module.exports = __webpack_public_path__ + "img/bath.81ad93c1.svg";